
import api from "@/services/api"
import { Severity } from "@/types/severity"

class ApiSeverity {
    private axios: any;
    public constructor (axios: any) { this.axios = axios }

    public async severityList (): Promise<Severity[]> { return (await this.axios.get("/severity")).data }
    public async severitySave (severity: Severity): Promise<string> { return (await this.axios.post("/severity", severity)).data }
    public async severityDelete (severity: Severity): Promise<void> { await this.axios.delete(`/severity/${severity.id}`) }
}

const apiSeverity = new ApiSeverity(api.getAxios())
export default apiSeverity
